import {Message} from "element-ui";
import server from '../../../public/server/server'
import store from '../../vuex/store.js'
// let reconnectflag = false;//避免重复连接
var limitConnect = 100;  // 断线重连次数
  var timeConnect = 0;
let wsurl=server.IM
//开启链接
function createWebSocket(callbak) {	
	if(localStorage.getItem('token')&&!store.state.isBreakIM&&!store.state.isIm){
		try {
		    if (!window.WebSocket) {
		        window.WebSocket = window.MozWebSocket;
		    }
		    if (window.WebSocket) {
		        window.websock = new WebSocket(wsurl);
		        window.websock.binaryType = "arraybuffer";
		        callbak();
		    }else {
		        Message.error('该浏览器不支持IM聊天')
		    }
		} catch (e) {
			// console.log(e);
		 //    reconnect(callbak);
		}
	}
}
function reconnect(callbak) {
      if(limitConnect>0){
          limitConnect --;
          timeConnect ++;
          console.log("第"+timeConnect+"次重连");
		 // 进行重连
		  setTimeout(function(){
			createWebSocket(callbak);
		  },5000);
          
      }else{
        console.log("TCP连接已超时");
      }
    }

export {createWebSocket,reconnect}
